import React, { useCallback, useRef } from 'react'
import { useMemo } from 'react'
import { canaliColumns } from './columns/_columns'
import GenericTable, {
  GenericTableHandle
} from '../../../../components/GenericTable'
import {
  PaginatedResponse,
  PaginationMeta
} from '../../../../interfaces/PaginatedResponse'
import { SalesChannel } from '../../../../interfaces/SalesChannel'
import { list } from '../../../../lib/fetch/salesChannels'
import { useAuth } from '../../../../context/Auth'

export interface CanaliTableProps {
  filters: any
}

const CanaliTable = ({ filters }: CanaliTableProps) => {
  const ref = useRef<GenericTableHandle>(null)
  const refetch = useCallback(() => {
    ref.current?.refetch()
  }, [ref])
  const columns = useMemo(() => canaliColumns(refetch), [])
  const [{ token }] = useAuth()
  const fetch = useCallback(
    async (
      paginationMeta: PaginationMeta
    ): Promise<PaginatedResponse<SalesChannel> | string> => {
      let result
      try {
        result = await list({
          token,
          page: paginationMeta.currentPage,
          limit: paginationMeta.itemsPerPage,
          ...filters
        })
      } catch (error) {
        let message = 'Error'
        if (error instanceof Error) {
          message = error.message
        }
        result = message
      }
      return result
    },
    [filters, token]
  )
  return <GenericTable columns={columns} onFetch={fetch} ref={ref} />
}

export { CanaliTable }
